<mat-card>
    <mat-card-content>
        <!-- <img class="card-image" [src]="image" alt=""> -->
        <p>{{texto}}</p>
    </mat-card-content>
    <mat-card-footer>{{nome}}</mat-card-footer>
</mat-card>